import React, { useState } from 'react';
import { IntegrationField } from 'api/integrations';
import { Filter } from 'components/molecules/filters/types';
import { useTranslation } from 'hooks/use-translation';
import { Content } from '../commons/content/content';
import { ConditionTypes } from '../commons/content/types';
import { ItemLayout } from '../layout';
import { CreateProps, StatusTypes } from '../use-automation-create';
import { TriggerSelectionModal } from './modal';

interface AutomationTriggerTypes
  extends Omit<CreateProps, 'integrationId' | 'defaultValue'> {
  data?: IntegrationField[];
  apiStatus: StatusTypes;
}

export const AutomationTrigger = ({
  data = [],
  apiStatus,
  automationDetails,
  onChange,
}: AutomationTriggerTypes): JSX.Element => {
  const [showModal, setShowModal] = useState(false);
  const title = useTranslation(
    'settings.integrations.sf.automation.create.trigger.title',
  );

  const handleSelection = (triggers: Filter) => {
    if (triggers.criteria.length) {
      onChange({
        ...automationDetails,
        triggers,
      });
    }
    setShowModal(false);
  };

  return (
    <div>
      <ItemLayout
        right={
          <Content
            contentFor={ConditionTypes.Triggers}
            salesforceObject={automationDetails?.salesforceObject}
            selectedConditions={automationDetails?.triggers}
            handleModalVisibility={setShowModal}
            loading={apiStatus === 'loading'}
          />
        }
        left={title}
        required
      />
      {automationDetails?.salesforceObject && showModal ? (
        <TriggerSelectionModal
          fields={data}
          fieldsStatus={apiStatus}
          value={automationDetails?.triggers}
          modalVisibility={showModal}
          handleModalVisibility={setShowModal}
          handleSelection={handleSelection}
        />
      ) : null}
    </div>
  );
};
